export default __webpack_public_path__ + "static/media/live-stream-icon.5f40bc22.png";